// src/utils/contrast.js
export function hexToLuminance(hex) {
  if (typeof hex !== 'string' || !hex.startsWith('#') || hex.length !== 7) {
    hex = '#000000'; // fallback to black
  }

  const r = parseInt(hex.substr(1, 2), 16);
  const g = parseInt(hex.substr(3, 2), 16);
  const b = parseInt(hex.substr(5, 2), 16);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function getContrastTextColor(bgColor) {
  if (!bgColor) return '#000';
  // parse hex
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 140 ? '#000000' : '#ffffff'; // solid black or white
}
